/* eslint-disable react/no-array-index-key */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Button from 'Components/UI/BehavioralFormElement/Button';

import './index.css';

class PagingLinksWithViewsButtons extends Component {
  constructor(props) {
    super(props);

    this.setPage = this.setPage.bind(this);
    this.setPageSize = this.setPageSize.bind(this);
  }

  setPage(val) {
    return (e) => {
      const { onPageChange, page } = this.props;
      e.preventDefault();
      if (val === page) return;
      onPageChange(val);
    };
  }

  setPageSize(val) {
    return (e) => {
      const { onPageSizeChange, pageSize } = this.props;
      e.preventDefault();
      if (val === pageSize) return;
      onPageSizeChange(val);
    };
  }

  render() {
    const {
      props: { page, pages, pageSizeOptions },
      setPage,
      setPageSize,
    } = this;
    const paging = [];
    let beforeEllipse = false;
    let afterEllipse = false;
    for (let i = 0; i < pages; i++) {
      if (
        i === 0
        || i === pages - 1 // || (page < 4 && i < 4) || (page > pages - 5 && i > pages - 5)
      ) {
        paging.push(i);
      } else if (i < page + 2 && i > page - 2) {
        paging.push(i);
      } else if (i < page && !beforeEllipse) {
        paging.push(null);
        beforeEllipse = true;
      } else if (i > page && !afterEllipse) {
        paging.push(null);
        afterEllipse = true;
      }
    }
    return (
      <div className="PagingLinksWithViewsButtons">
        <div className="paging">
          <span>Page:</span>
          <span className="pages">
            {paging.map((n, i) => (n === null ? (
              <span key={i}>...</span>
            ) : (
              <Link key={i} to="" onClick={setPage(n)}>
                {n + 1}
              </Link>
            )))}
          </span>
        </div>
        <div className="viewing">
          <span>View Per Page</span>
          <div className="views">
            {pageSizeOptions.map(n => (
              <Button key={n} onClick={setPageSize(n)}>
                {n}
              </Button>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

PagingLinksWithViewsButtons.propTypes = {
  onPageChange: PropTypes.func.isRequired,
  onPageSizeChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  pages: PropTypes.number.isRequired,
  pageSize: PropTypes.number.isRequired,
  pageSizeOptions: PropTypes.arrayOf(PropTypes.number).isRequired,
};

export default PagingLinksWithViewsButtons;
